import { VerifyAlbumFnReq, VerifyAlbumFnRes, VerifyFolderResult } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class VerifyAlbumInteractor {
  private readonly verifyAlbumFn = httpsCallable<VerifyAlbumFnReq, VerifyAlbumFnRes>(
    this.functions,
    'verifyAlbum',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(albumId: string): Promise<VerifyFolderResult> {
    const res = await this.verifyAlbumFn({
      auth: await this.getAuthDto.execute(),
      id: albumId,
    });

    return res.data.result;
  }
}
